export function formatWeight(weight?: string | number): string {
  return (Number(weight) || 0).toFixed(3)
}
